import { LitElement } from "lit";
import { SelectedState } from "./selected-state.js";
import { property, state } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class BaseElement extends LitElement {
  constructor() {
    super(...arguments);
    this.debug = false;
    this.selectedState = SelectedState.UNKNOWN;
    this.errors = [];
  }
  async validate() {
    const currentErrors = [];
    const isInsuranceValid = this.selectedState != SelectedState.UNKNOWN;
    if (!isInsuranceValid) {
      currentErrors.push("selection_required");
    }
    this.errors = currentErrors;
    return {
      isValid: isInsuranceValid,
      errors: currentErrors
    };
  }
}
__decorateClass([
  property({ type: Boolean, attribute: "debug" })
], BaseElement.prototype, "debug");
__decorateClass([
  property({ attribute: "client-id" })
], BaseElement.prototype, "clientId");
__decorateClass([
  property({ attribute: "customer-client-secret" })
], BaseElement.prototype, "customerClientSecret");
__decorateClass([
  property({ type: Number })
], BaseElement.prototype, "selectedState");
__decorateClass([
  state()
], BaseElement.prototype, "errors");
export {
  BaseElement
};
